// React dependencies
import React, { useRef } from 'react';

// External dependencies
import PropTypes from 'prop-types';
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';

// Internal dependencies
import MText from '../common/MText';
import MButton from '../common/MButton';
import Colours from '../../styles/colours';
import PoiMap from '../common/poi/poiMap';
import Images from '../basics/Images';

const MapModal = (props) => {
  // Here we use useRef instead of useState to prevent unnecessary re-rendering on the map
  // Since when we change the marker position, the map will do rerendering to calculate the center point
  // With useRef, we will only store the marker location without forcing the map to recalculate the center of the map
  const currentCoord = useRef(props.coord || {
    lat: null,
    lng: null,
  });

  const onMarkerChange = (updatedCoord) => {
    currentCoord.current = updatedCoord;
  };

  const onApply = () => {
    props.onApply(currentCoord.current);
    props.closeMapModal();
  };

  return (
    <Dialog
      open={props.showMapModal}
      onClose={props.closeMapModal}
      fullWidth
      maxWidth="lg"
    >
      <DialogTitle className="px-4 px-lg-5">
        <div className="d-flex justify-content-between align-items-center">
          <MText variant="h1" text="Map" />
          <IconButton aria-label="close" onClick={props.closeMapModal}>
            <CloseIcon />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent className="px-lg-4 px-2">
        <PoiMap
          mapHeight="65dvh"
          coord={props.coord}
          isPoiMarker
          markerScaledSize={props.markerScaledSize}
          markerIcon={props.markerIcon}
          onMarkerChange={onMarkerChange}
        />
      </DialogContent>
      <DialogActions className="mb-4 px-4 px-lg-5">
        <MButton
          text="Cancel"
          textColour={Colours.Primary}
          textStyle={{ fontWeight: 500 }}
          onClick={props.closeMapModal}
          variant="text"
        />
        <MButton
          colour={Colours.MaterialBlue}
          textStyle={{ fontWeight: 500 }}
          textColour={Colours.White}
          text="Apply"
          onClick={onApply}
        />
      </DialogActions>
    </Dialog>
  );
};

MapModal.defaultProps = {
  markerIcon:       Images.Local.MarkerPoi,
  markerScaledSize: 40,
};

MapModal.propTypes = {
  showMapModal: PropTypes.bool.isRequired,
  coord:        PropTypes.shape({
    lat: PropTypes.number,
    lng: PropTypes.number,
  }).isRequired,
  markerIcon:       PropTypes.string,
  markerScaledSize: PropTypes.number,

  closeMapModal: PropTypes.func.isRequired,
  onApply:       PropTypes.func.isRequired,
};

export default MapModal;
